var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29151_36812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91306 19.2101L16.9132 11.2099L13.1133 7.41L5.11312 15.4102C5.00298 15.5205 4.92475 15.6585 4.88671 15.8096L4 20.3232L8.51275 19.4365C8.66426 19.3987 8.80286 19.3203 8.91306 19.2101ZM19.4959 8.62729C19.8187 8.30441 20 7.86655 20 7.41C20 6.95345 19.8187 6.51559 19.4959 6.19271L18.1305 4.82735C17.8077 4.50457 17.3698 4.32324 16.9132 4.32324C16.4567 4.32324 16.0188 4.50457 15.696 4.82735L14.3306 6.19271L18.1305 9.99265L19.4959 8.62729Z",
    fill: "#00538F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29151_36812)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.324219,
    width: 24,
    height: 24,
    fill: "#00538F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit_button.ef67413562609797db716cdc82bcb12d.svg";
export { ForwardRef as ReactComponent };